module.exports = __webpack_public_path__ + "media/images/athletes/1904-18d8f2a7055a1c8fc5f3eb8fc2374dcc.png";